<template>
  <div
    class="alert p-2 rounded mb-3 py-2"
    :class="{
      'bg-pink-1': error,
      'bg-secondary-41': warning,
    }"
  >
    <div class="d-flex align-items-center">
      <em
        class="font-16 pl-2 ml-1 "
        :class="{
          'fas fa-times-circle color-secondary-20': error,
          'fas fa-bell-exclamation color-secondary-40': warning,
        }"
      />
      <div
        class="font-14 font-weight-normal ml-3"
        :class="{
          'color-secondary-20': error,
          'color-secondary-40': warning,
        }"
      >
        {{ text }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ResultRowMessage',
  props: {
    text: {
      type: String,
      default: () => '',
    },
    error: {
      type: Boolean,
      default: () => false,
    },
    warning: {
      type: Boolean,
      default: () => false,
    },
  },
};
</script>
